import { mergeStyles, Stack } from "@fluentui/react";
import { Card, tokens } from "@fluentui/react-components";
import { PRODUCT_VIEW_STYLES as styles } from "../../../Common/ProductView.styles";
import { ProductCard } from "../Common/ProductCard";
import { useGetProductExploreDataQuery } from "../../../../../slices/ExploreProducts.slice";

export const ProductListCardsContainer = ({ selectedFamily }: { selectedFamily: string }) => {
  const { data, isLoading, isError } = useGetProductExploreDataQuery(null);

  if (isError) return <Card style={{ margin: tokens.spacingVerticalL }}>Error loading data</Card>;

  return (
    <Stack
      horizontal
      wrap
      styles={styles.PRODUCT_LIST.CSS_STYLES.productListCardsContainer}
      className={mergeStyles({
        inner: {
          color: "red"
        }
      })}
    >
      {isLoading
        ? Array.from({ length: 5 }).map(() => (
            <Stack.Item key={`loading-${crypto.randomUUID()}`} grow={false} disableShrink>
              <ProductCard
                chartData={[]}
                currentValue={0}
                loading={isLoading}
                momVariance={0}
                productFamily={selectedFamily}
                productKpiName=""
                productName=""
                productId={0}
                size="large"
                style={{ cursor: "pointer" }}
              />
            </Stack.Item>
          ))
        : data
            ?.filter(({ productFamily }: any) => productFamily === selectedFamily)
            .map(({ productId, productName, metricData }: any) => (
              <Stack.Item key={productName} grow={false} disableShrink>
                <ProductCard
                  {...metricData.at(0)}
                  size="large"
                  style={{ cursor: "pointer" }}
                  productFamily={selectedFamily}
                  productName={productName}
                  productId={productId}
                  loading={isLoading}
                />
              </Stack.Item>
            ))}
    </Stack>
  );
};
